/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isAuthorized } from 'utils/app.utils';
import { withStyles } from '@eagleview/ev-comp-library';
import { connect } from 'react-redux';

/**
 * PrivateRoute - if authenticated, renders passed component else redirects to '/authorize/callback'
 * @param {Object} props
 * @param {Element} component - React component to be rendered
 */
const PrivateRoute = ({
  component: Component, shouldSidebarRender, showNewUI, classes, ...rest
}) => {
  const contentStyle = showNewUI || !shouldSidebarRender ? classes.content : classes.contentOld;
  return (
    <Route
      {...rest}
      render={(props) => (isAuthorized() ? (
        <div className={contentStyle}>
          <Component {...props} />
        </div>
      ) : (
        <Redirect
          to={{
            pathname: '/authorize/callback',
            state: { subRoute: (window.location.pathname + window.location.search + window.location.hash) },
          }}
        />
      ))}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.shape().isRequired,
  shouldSidebarRender: PropTypes.bool.isRequired,
  showNewUI: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    content: PropTypes.string.isRequired,
    contentOld: PropTypes.string.isRequired,
  }).isRequired,
};

const styles = {
  content: {
    flex: 1,
  },
  contentOld: {
    marginLeft: '63px', // #genai matches PrimaryNavBarOld collapsed drawer width
    flex: 1,
  },
};

const selector = (state) => ({
  shouldSidebarRender: state.SideBar.shouldSidebarRender,
  showNewUI: state.SideBar.showNewUI,
});

export default withStyles(styles)(connect(selector)(PrivateRoute));
